// src/utils/authUtils.ts

import { useRecoilState } from 'recoil'
import { authState } from '../atoms/auth'
import { getUser } from '../services/apiService'

export const useAuthState = () => {
  const [auth, setAuth] = useRecoilState(authState)

  const reloadUser = async () => {
    try {
      const { data: res } = await getUser()
      if (res.statusCode === 200) {
        setAuth(res.data)
      }
    } catch (error) {
      // 에러 스킵
    }
  }

  const reloadUserErr = async () => {
    try {
      const { data: res } = await getUser()
      if (res.statusCode === 200) {
        setAuth(res.data)
      }
    } catch (error) {
      throw error
    }
  }

  const initUser = async () => {
    setAuth({
      id: null,
      account: null,
      username: null,
      isAdmin: null,
      isApproved: null,
      createdAt: null,
      updatedAt: null,
      deletedAt: null,
    })
  }

  // ✅ 반환 추가
  return {
    reloadUser,
    reloadUserErr,
    initUser
  }
}
